/**
 * 工具库
 */

/**
 * 生成随机数
 */
function _randomWord(randomFlag, min, max) {
	var str = "",
		range = min,
		arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

	// 随机产生
	if (randomFlag) {
		range = Math.round(Math.random() * (max - min)) + min;
	}

	for (var i = 0; i < range; i++) {
		var pos = Math.round(Math.random() * (arr.length - 1));
		str += arr[pos];
	}

	return str;
}

/**
 * 创建获取随机数的方法的方法
 * @param {number} num 随机数位数
 * @returns {function}
 */
function _createSessionId(num) {
	let _sessionId = '';

	return function () {
		if (!_sessionId) {
			_sessionId = _randomWord(false, num);
		}

		return _sessionId;
	}
}

// 获取随机数
const getSessionId = _createSessionId(32);

function delCookie(name) {
	var path_domain = "; path=/; domain=weidian.com";
	if (document.domain.indexOf('koudai.com') !== -1) {
		path_domain = "; path=/; domain=koudai.com";
	}
	document.cookie = name + "=; expires=" + new Date(0).toUTCString() + path_domain;
}

function getCookie(name) {
	var cookie_start = document.cookie.indexOf(name + "="),
		cookie_end = document.cookie.indexOf(";", cookie_start);
	return cookie_start == -1 ? "" : document.cookie.substring(cookie_start + name.length + 1, (cookie_end > cookie_start ? cookie_end : document.cookie.length));
}

/**
 *   isSession 标识cookie是否在关闭浏览器后清除,默认有效期一个月
 *   $.setCookie(key, value, isSession)
 *
 *   $.setCookie({key1:value1, key2:value2}, isSession)
 *
 */
function setCookie(name, value, isSession) {
	var expires = new Date();
	expires.setTime(expires.getTime() + 2592000000); //1month
	var path_domain = "; path=/" + (document.domain.indexOf("vdian.com") != -1 ? "; domain=vdian.com" : (document.domain.indexOf("koudai.com") != -1 ? "; domain=koudai.com" : (document.domain.indexOf("weidian.com") != -1 ? "; domain=weidian.com" : "")));
	if (typeof (name) === "object") {
		for (var v in name) {
			if (name[v] != '' || name[v] === 0 || name[v].length) { //如果值为空，就不设置cookie
				console.log(Number(name[v]) + '_' + name[v].length)
				//console.log(name[v].length)
				var cookie_content = escape(v) + "=" + escape(name[v]);
				document.cookie = cookie_content + "; expires=" + expires.toGMTString() + path_domain;
			}
		}
	} else {
		if (value != '' || value === 0 || value.length) { ////如果值为空，就不设置cookie
			var cookie_content = escape(name) + "=" + escape(value);
			document.cookie = cookie_content + (isSession ? "" : ("; expires=" + expires.toGMTString())) + path_domain;
		}
	}
}

function formatTime(s) {
	var arr = s.split(" ");
	var date = arr[0].split("-");
	var time = arr[1].split(":");
	var y = date[0];
	var m = date[1];
	var d = date[2];
	var _string = new Date();
	var _y = _string.getFullYear();
	var _m = _string.getMonth() + 1;
	var _d = _string.getDate();
	if (y == _y && m == _m && d == _d) {
		var _hours = Number(time[0]);
		var _hours_str = (_hours < 12) ? (_hours < 6 ? "凌晨 " + _hours : "上午 " + _hours) : ((_hours > 12) ? (_hours >= 18 ? "晚上 " + (_hours - 12) : "下午 " + (_hours - 12)) : "中午 12");
		return _hours_str + ":" + time[1];
	} else {
		//console.log("不是同一天发的 直接显示 "+ y.toString().substring(2) +"-"+ m +"-"+ d);
		return y.toString().substring(2) + "-" + m + "-" + d;
	}
}

function getLocalTime(tm) {
	var tm = tm - 0;
	var da = tm;
	da = new Date(da);
	var year = da.getFullYear();
	var month = da.getMonth() + 1;
	var date = da.getDate();
	var h = da.getHours();
	var m = da.getMinutes();
	var s = da.getSeconds();
	var datatime = year + '-' + month + '-' + date + ' ' + h + ':' + (m * 1 >= 10 ? m : "0" + m * 1) + ':' + s
	return formatTime(datatime)
}

// 解析表情 parseFace :: (Object, string) -> string
function parseFace(faceMap, msg) {
	msg = msg.replace(/(\[.*?\])/g, (face) => {
		if (faceMap[face]) {
			return `<img src="${faceMap[face]}" alt="${face}" width="24" height="24"/>`;
		} else {
			return face;
		}
	});

	return msg;
}

export {
	getSessionId,
	getCookie,
	setCookie,
	delCookie,
	getLocalTime,
	parseFace
}



/** WEBPACK FOOTER **
 ** ./lib/util.js
 **/